import React from "react";
import { IonModal } from "@ionic/react";
import styled from "styled-components";

import logoInserm from "../../assets/MentalPlus/LogoInserm.png";
import logoEceve from "../../assets/MentalPlus/logoECEVE.png";
import logoUPC from "../../assets/MentalPlus/logoUPC.png";
import logoAPHP from "../../assets/MentalPlus/logoAPHP.gif";
import logoSante from "../../assets/MentalPlus/LogoMinistereSante.png";
import logoEduc from "../../assets/MentalPlus/LogoMinistereEduc.png";
import logoAXA from "../../assets/MentalPlus/logoAXA.png";

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
};


const logosTop = [
  { src: logoInserm, offsetY: 0, scale: 1 },
  { src: logoEceve, offsetY: 2, scale: 1 },
  { src: logoUPC, offsetY: 0, scale: 1 },
  { src: logoAPHP, offsetY: 3, scale: 1 },
];

const logosBottom = [
  { src: logoSante, offsetY: 2, scale: 1.5 }, 
  { src: logoEduc, offsetY: 4, scale: 1.3 },
  { src: logoAXA, offsetY: 1, scale: 1 },
];

const AboutModal: React.FC<Props> = ({ isOpen, onDismiss }) => {
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onDismiss}
      breakpoints={[0, 1]}
      initialBreakpoint={1}
    >
      <Container>
        <Header>
          <Title>Qui sommes-nous ?</Title>
          <CloseButton onClick={onDismiss}>×</CloseButton>
        </Header>

        {/* TEXTE */}
        <Text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua.
        </Text>

        <Text>
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
          ut aliquip ex ea commodo consequat.
        </Text>

        <Text>
          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
          dolore eu fugiat nulla pariatur.
        </Text>

        {/* 🔝 4 LOGOS */}
        <LogosGrid>
          {logosTop.map((logo, i) => (
            <Logo
              key={i}
              src={logo.src}
              $offsetY={logo.offsetY}
              $scale={logo.scale}
            />
          ))}
        </LogosGrid>

        {/* 🔽 TITRE */}
        <PartnersTitle>Nos partenaires</PartnersTitle>

        {/* 🔽 3 LOGOS */}
        <LogosRow>
          {logosBottom.map((logo, i) => (
            <Logo
              key={i}
              src={logo.src}
              $offsetY={logo.offsetY}
              $scale={logo.scale}
            />
          ))}
        </LogosRow>
      </Container>
    </IonModal>
  );
};

export default AboutModal;



const Container = styled.div`
  padding: 20px;
  background: #f8f9fc;
  min-height: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 1.6rem;
  margin: 0;
`;

const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: white;
  font-size: 1.5rem;
  cursor: pointer;
`;

const Text = styled.p`
  margin: 16px 0;
  font-size: 1rem;
  line-height: 1.7;
  color: #5f6b85;
`;

/* 🔝 4 logos */

const LogosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;
  gap: 10px;
  margin-top: 10px;

  @media (min-width: 600px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;



const LogosRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 10px;
  flex-wrap: wrap;
`;

const PartnersTitle = styled.h2`
  font-size: 1.3rem;
  margin: 14px 0 10px;
  text-align: center;
`;



const Logo = styled.img<{ $offsetY?: number; $scale?: number }>`
  height: 55px;
  width: auto;
  object-fit: contain;

  opacity: 0.9;
  transition: 0.2s;

  transform: translateY(${(props) => props.$offsetY || 0}px)
    scale(${(props) => props.$scale || 1});

  &:hover {
    opacity: 1;
    transform: translateY(${(props) => props.$offsetY || 0}px)
      scale(${(props) => (props.$scale || 1) * 1.05});
  }
`;